import Loader from "@components/Loader";
import { useDashboardUIActions } from "@contexts/dashboardUI";
import { useProjectActions } from "@contexts/projects";
import { updateForm, deleteForm } from "@outlets/registerForm/functions";
import { formatDateDMY, formatDateToNumberMMYY } from "@utils/formatDate";
import { useEffect, useState } from "react";


const unlockForm = async (id, infos) => {
  const { setIsLoading } = useDashboardUIActions();
  setIsLoading(true)
  await updateForm(id, infos, false)
  setIsLoading(false)
  // window.location.reload();
}

const handleDeleteForm = async (id) => {
  const { setIsLoading } = useDashboardUIActions();
  setIsLoading(true)
  await deleteForm(id)
  setIsLoading(false)
  // window.location.reload();
}

const definitions = [
  { label: "Rodapés", name: "baseboards" },
  { label: "Paredes", name: "wallsRevest" },
  { label: "Pisos", name: "floors" },
  { label: "Tetos", name: "ceiling" },
  { label: "Guarda-corpos", name: "guardrail" },
  { label: "Piscinas", name: "pools" },
  { label: "Escadas", name: "stairs" },
  { label: "Paredes hidráulicas", name: "hidrWalls" },
  { label: "Áreas privativas", name: "privAreas" }
]

const defaultLine = (label, value, extra) => {
  if (!value || value === "" || value.length === 0) return;
  const res = typeof value === "string" ? value : value.join(", ");
  return <p className="black">{label}: {res.toLowerCase().includes("outro") ? `${res} - ${extra}` : res}</p>
}

const thicknessLine = (label, arr, extra) => {
  let res = []
  arr.forEach(element => {
    if (element.thickness && element.thickness > 0) {
      res.push(`${element.type} (${element.thickness} cm)`);
    } else if (element.type === "Outro") {
      res.push(`Outro - ${extra}`)
    } else {
      res.push(element.type);
    }
  });
  if (!res || res.length === 0) return;
  return <p className="black">{label}: {res.join(", ")}</p>
}

const DefaultRow = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pre, setPre] = useState(false)
  const [client, setClient] = useState(false)
  const { clientInfos } = item;

  const download = () => {
    const roomsWithBaseBoards = item.roomDefinitions.baseboards;
    const basebardGroupsRooms = item.clientInfos.baseboardGroups.flatMap(i => i.rooms);
    const roomsNotInGroups = roomsWithBaseBoards.filter(i => !basebardGroupsRooms.includes(i));
    const itemCopy = { ...item };
    if (roomsNotInGroups.length > 0) {
      itemCopy.clientInfos.baseboardGroups.push({
        rooms: roomsNotInGroups,
        type: "Nenhum",
      });
    }
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(itemCopy, null, 2)], { type: "application/json" });
    element.href = URL.createObjectURL(file);
    element.download = `${item.name}.json`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  const openForm = () => {
    const currentUrl = window.location.origin;
    const newWindow = window.open(`${currentUrl}/clientForm/${item._id}`, "_blank", "noopener,noreferrer");
    if (newWindow) {
      newWindow.opener = null;
    }
  }



  return <div className="accordion-item margin-bottom-8">
    <div style={{ border: "1px solid #f1f1f1", backgroundColor: "#f8f8f8", padding: "8px", borderRadius: "4px" }}>
      <div className="grid columns-6 gap-8" style={{ alignItems: 'center' }}>
        <div className="flex gap-8 column-span-2">
          <button
            className={`accordion-toggle ${isOpen ? "active" : ""}`}
            onClick={() => setIsOpen(!isOpen)}
          ></button>
          <span className="accordion-title" style={{ textTransform: 'none' }}>{item.name} {item.clientInfos && (item.completed ? "- Completo" : "- Parcial")}</span>
        </div>
        <div className="data column-span-2">
          <span className="accordion-label">Preenchido por</span>
          <span className="accordion-title" style={{ textTransform: 'none' }}>{item.clientInfos?.user?.name} - {item.clientInfos?.user?.email}</span>
        </div>
        <div className="data">
          <span className="accordion-label">Última atualização em</span>
          <span className="accordion-title">{formatDateDMY(item.updated_at)}</span>
        </div>
        <div className="flex justify-content-space-around">
          <button className="toggle-offcanvas" onClick={openForm} title="Abrir formulário">
            <i
              className="icon icon-width-24 icon-external-link"
              aria-hidden={true}
            />
          </button>

          <button className="toggle-offcanvas" onClick={() => handleDeleteForm(item._id)} title="Deletar formulário">
            <i
              className="icon icon-width-24 icon-circle-x"
              aria-hidden={true}
            />
          </button>
          <button className="toggle-offcanvas" onClick={download} title="Baixar formulário">
            <i
              className="icon icon-width-24 icon-download"
              aria-hidden={true}
            ></i>
          </button>
          {item.completed && <button className="toggle-offcanvas" onClick={() => unlockForm(item._id, item.clientInfos)} title="Liberar formulário para edição">
            <i
              className="icon icon-width-24 icon-unlock"
              aria-hidden={true}
            ></i>
          </button>}
        </div>
      </div>
    </div>
    <div className="margin-left-16 advancement-infos-container">
      {isOpen && <>
        <div className="accordion-item">
          <div className="accordion-item-body column-span-1">
            <div>
              <div className="flex align-center gap-8">
                <button
                  className={`accordion-toggle ${pre ? "active" : ""}`}
                  onClick={() => setPre(!pre)}
                ></button>
                <div className="grid">
                  <span className="accordion-title">Pré-cadastro</span>
                </div>
              </div>
            </div>
          </div>
          {pre && <div className="margin-left-16 advancement-infos-container">
            <div className="accordion-item-body margin-bottom-8" style={{ display: "block" }}>
              <label className="bold">Salas</label>
              <p className="margin-bottom-8 margin-left-8">{item.rooms.join(", ")}</p>
              <label className="bold">Pavimentos</label>
              <p>{item.pavements.map(i => {
                return <div className="margin-left-8 margin-bottom-4">
                  <h3>{i.pavement}</h3>
                  <p>{i.rooms.join(", ")}</p>
                </div>
              })}</p>
              <label className="bold">Projeto possui</label>
              <p>{item.projectHas.join(", ")}</p>
              <label className="bold">Informações completas no projeto:</label>
              <p className="margin-bottom-8 margin-left-8">{item.projRoomFull.join(", ")}</p>
              {definitions.map(i => {
                return <div className="margin-bottom-8">
                  <label className="bold">{i.label}:</label>
                  <p className="margin-left-8">{item.roomDefinitions[i.name].join(", ")}</p>
                </div>
              })}
            </div>
          </div>}
        </div>
        <div className="accordion-item">
          <div className="accordion-item-body column-span-1">
            <div>
              <div className="flex align-center gap-8">
                <button
                  className={`accordion-toggle ${client ? "active" : ""}`}
                  onClick={() => setClient(!client)}
                ></button>
                <div className="grid">
                  <span className="accordion-title">Informações do cliente</span>
                </div>
              </div>
            </div>
          </div>
          {(client && clientInfos) && <div className="margin-left-16 advancement-infos-container">
            <div className="accordion-item-body margin-bottom-8" style={{ display: "block" }}>
              <h3 className="bold">Telhado</h3>
              <div className="margin-left-16">
                {defaultLine("Tipo de telhado", clientInfos.roofType, clientInfos.roofTypeExtra)}
                {defaultLine("Estrutura de telhado", clientInfos.roofStructure, clientInfos.roofStructureExtra)}
                {defaultLine("Tipo de calha", clientInfos.roofGutter, clientInfos.roofGutterExtra)}
              </div>

              <h3 className="bold">Molduras</h3>
              <div className="margin-left-16">
                {defaultLine("Material das Molduras", clientInfos.frameType)}
                {clientInfos.extraFrame !== "" && defaultLine("Material extra", clientInfos.extraFrame)}
              </div>

              <h3 className="bold">Peitoris</h3>
              <div className="margin-left-16">
                {defaultLine("Estrutura", clientInfos.frameType)}
                {clientInfos.extraFrame !== "" && defaultLine("Material extra", clientInfos.extraFrame)}
              </div>

              <h3 className="bold">Pergolado</h3>
              <div className="margin-left-16">
                {defaultLine("Estrutura", clientInfos.pergola, clientInfos.pergolaExtra)}
                {clientInfos?.pergola?.toLowerCase().includes("concreto") && defaultLine("Acabamento igual do ambiente", clientInfos.extraFrame)}
              </div>

              <h3 className="bold">Vagas</h3>
              <div className="margin-left-16">
                {defaultLine("Estrutura", clientInfos.parking, clientInfos.parkingExtra)}
              </div>

              <h3 className="bold">Rufos</h3>
              <div className="margin-left-16">
                {defaultLine("Onde considerar rufos", clientInfos.flashing, clientInfos.flashingExtra)}
                {clientInfos?.flashing?.includes("Muros acima de altura X") && defaultLine("Muros acima de (CM):", clientInfos.flashingHeight)}
                {defaultLine("Material", clientInfos.flashingMats, clientInfos.flashingMatsExtra)}
              </div>

              <h3 className="bold">Soleiras</h3>
              <div className="margin-left-16">
                {defaultLine("Portas com soleira", clientInfos.thresholdLocs)}
                {defaultLine("Material", clientInfos.thresholdMats, clientInfos.thresholdMatsExtra)}
              </div>

              <h3 className="bold">Piscina</h3>
              <div className="margin-left-16">
                {clientInfos.poolGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {defaultLine("Estrutura", group.structure, group.structureExtra)}
                    {defaultLine("Acabamento superior", group.upperFinish, group.upperFinishExtra)}
                    {defaultLine("Acabamento Externo", group.externalFinish, group.externalFinishExtra)}
                  </div>
                })}
              </div>

              <h3 className="bold">Guarda-corpos</h3>
              <div className="margin-left-16">
                {clientInfos.guardrailGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {defaultLine("Tipo de guarda-corpo", group.type, group.typeExtra)}
                  </div>
                })}
              </div>

              <h3 className="bold">Escadas</h3>
              <div className="margin-left-16">
                {clientInfos.stairsGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {defaultLine("Estrutura", group.structure, group.structureExtra)}
                    {thicknessLine("Pré-acabamento dos pisos", group.preFinish, group.preFinishExtra)}
                    {defaultLine("Acabemento dos pisos", group.finish, group.finishExtra)}
                    {thicknessLine("Pré-acabamento do teto", group.roofPrefinish, group.roofPrefinishExtra)}
                    {defaultLine("Acabemento do teto", group.roofFinish, group.roofFinishExtra)}
                    {(group?.roofFinish?.toLowerCase() === "pintura" || group?.roofFinish?.toLowerCase() === "textura branca + pintura" || group?.roofFinish?.toLowerCase() === "textura pigmentada") && defaultLine("Cor/Código do acabemento do teto", group.roofFinishColor)}
                    {defaultLine("Corrimões", group.handrail, group.handrailExtra)}
                  </div>
                })}
              </div>

              <h3 className="bold">Pisos</h3>
              <div className="margin-left-16">
                {clientInfos.floorGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
                    {defaultLine("Acabemento", group.finish, group.finishExtra)}</div>
                })}
              </div>

              <h3 className="bold">Tetos</h3>
              <div className="margin-left-16">
                {clientInfos.ceilingGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
                    {defaultLine("Acabemento", group.finish, group.finishExtra)}
                  </div>
                })}
              </div>

              <h3 className="bold">Paredes</h3>
              <div className="margin-left-16">
                {clientInfos.wallGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
                    {defaultLine("Acabemento", group.finish, group.finishExtra)}
                    {group.hidrWallFinish !== "" && defaultLine("Acabamento de paredes hidráulicas", group.hidrWallFinish, group.hidrWallFinishExtra)}
                    {group.isPillarDiff === "Sim" && defaultLine("Pré-acabamento de pilares e vigas", group.pillarDiff, group.pillarDiff)}

                  </div>
                })}
              </div>

              <h3 className="bold">Rodapés</h3>
              <div className="margin-left-16">
                {clientInfos.baseboardGroups.map((group, idx) => {
                  return <div key={idx}>
                    <p className="black">Grupo {idx + 1}</p>
                    <p className="small-reminder">{group.rooms.join(", ")}</p>
                    {defaultLine("Tipo", group.type, group.typeExtra)}
                    {defaultLine("Altura", group.height, group.height)}
                  </div>
                })}
              </div>
            </div>
          </div>}
        </div>
      </>}
    </div>
  </div>
}



const CartesianForms = () => {
  const { getAllCartesianForm } = useProjectActions()
  const [allForms, setAllForms] = useState([]);
  const [loading, setLoading] = useState(false);

  const getForms = async () => {
    setLoading(true)
    const res = await getAllCartesianForm()
    setAllForms(res.items)
    setLoading(false)
  }

  useEffect(() => {
    getForms()
  }, [])



  return <div>
    <h1>Formulários</h1>
    {loading ? <Loader /> : allForms.map(i => {
      return <DefaultRow item={i} />
    })}
  </div>
}

export default CartesianForms;